export const baseAddress = 'https://chargepointhubapi.azurewebsites.net';
export const authority = "https://bmslogin.cas.dtu.dk/";
export const client_id = "chargepointhubweb";
export const redirect_uri = "https://chargepointhub.dk/";